import { CommonPullupMenuComponent } from './../../modal-screens/common-pullup-menu/common-pullup-menu.component';
import { ActivatedRoute } from '@angular/router';
// compitition-service.ts ---
// line no 737 comment --- comprize

import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavController, NavParams, Platform } from '@ionic/angular';
import { adjustViewZIndex } from 'src/globals';
import { isPresent } from 'src/providers/common-service';
import { CompetitionService } from 'src/providers/competition-service/competition-service';
import {
  CompetitionCategory,
  CompetitionInfo,
  CompetitionPrizeInfo,
  GameroundPrize,
} from './../../../../data/competition-data';
import { Location } from '@angular/common';
import { CompetitionData, CompetitionPrizeData } from 'src/data/mygolf.data';
import { ImageZoomPage } from '../../modal-screens/image-zoom/image-zoom.page';

@Component({
  selector: 'app-competition-prizes',
  templateUrl: './competition-prizes.page.html',
  styleUrls: ['./competition-prizes.page.scss'],
})
export class CompetitionPrizesPage implements OnInit {
  public competition: CompetitionInfo;
  public prizes: Array<any>; //Array<CompetitionPrizeInfo>;
  public roundNo: Array<number> = new Array<number>();
  public prizeMap: any = {};
  public compPrizes: Array<CompetitionPrizeInfo> = [];
  public compDataPrizes: Array<CompetitionPrizeData> = [];
  public roundwisePrizes: Array<Array<CompetitionPrizeInfo>> = [];
  public categories: Array<any> = new Array<any>();
  // Array<CompetitionCategory> = new Array<CompetitionCategory>();

  public gameRoundPrizes: Array<any> = []; //GameroundPrize

  public teamRoundwisePrizes: Array<Array<CompetitionPrizeInfo>> = [];
  public teamPrizes: Array<CompetitionPrizeInfo>;
  public compTeamPrizes: Array<CompetitionPrizeInfo> = [];
  public gameRoundTeamPrizes: Array<GameroundPrize> = [];

  appFooterHide: boolean = true;
  searchQuery: string = '';

  compId: number;

  showPrizeTab: string = 'individual'; //team
  viewMode: string = 'card';
  public compData: CompetitionData;
  constructor(
    private router: Router,
    private nav: NavController,
    private navParams: NavParams,
    private renderer: Renderer2,
    private competitionService: CompetitionService,
    private route: ActivatedRoute,
    private location: Location,
    private modalCtl: ModalController,
    private platform: Platform
  ) {
    if (!this.router.getCurrentNavigation().extras.state) {
      this.onHomeClick();
    }
    this.competition = this.router.getCurrentNavigation().extras.state.competition;
    this.compId = this.router.getCurrentNavigation().extras.state.compId;
    this.prizes = this.router.getCurrentNavigation().extras.state.prizes;
    this.compDataPrizes = this.router.getCurrentNavigation().extras.state.compDataPrizes;
    this.teamPrizes = this.router.getCurrentNavigation().extras.state.teamPrizes;
    this.categories = this.router.getCurrentNavigation().extras.state.categories;
    this.compData = this.router.getCurrentNavigation()?.extras.state.compData;
    this.prizeMap = {};

    this.prizes.forEach((pr: any) => {
      // CompetitionPrizeInfo
      if (pr.roundNumber >= 99) {
        this.compPrizes.push(pr);
      } else {
        if (!isPresent(this.roundwisePrizes[pr.roundNumber])) {
          this.roundwisePrizes[pr.roundNumber] = [];
        }
        this.roundwisePrizes[pr.roundNumber].push(pr);
      }
    });
    //
    console.debug('grouping prize prizes : ', this.prizes);
    console.debug('grouping prize compPrizes : ', this.compPrizes);
    console.debug('grouping prize gameRoundPrizes : ', this.gameRoundPrizes);
    console.debug('grouping prize roundWisePrizes : ', this.roundwisePrizes);
    this.newGameRoundPrizes = this.competitionService.groupedPrizes(this.prizes);
    this.gameRoundPrizes = this.competitionService.newGroupedPrizes(this.compDataPrizes);

    this.sortGameRoundPrizes();
    //
    this.teamPrizes.forEach((pr: CompetitionPrizeInfo) => {
      if (pr.roundNumber >= 99) {
        this.compTeamPrizes.push(pr);
      } else {
        if (!isPresent(this.teamRoundwisePrizes[pr.roundNumber])) {
          this.teamRoundwisePrizes[pr.roundNumber] = [];
        }
        this.teamRoundwisePrizes[pr.roundNumber].push(pr);
      }
    });
    this.gameRoundTeamPrizes = this.competitionService.groupedPrizes(this.teamPrizes);

    console.debug('OLD game round grouping prizes : ', this.newGameRoundPrizes);
    console.debug('new game round grouping prizes : ', this.gameRoundPrizes);
    console.debug('categories grouping prizes : ', this.categories);
  }
  newGameRoundPrizes;
  ngOnInit() {}

  ionViewDidEnter() {
    adjustViewZIndex(this.nav, this.renderer);
  }

  prizesExist(roundNumber: number) {
    if (
      isPresent(this.roundwisePrizes[roundNumber]) &&
      this.roundwisePrizes[roundNumber].length > 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  teamPrizesExist(roundNumber: number) {
    if (
      isPresent(this.teamRoundwisePrizes[roundNumber]) &&
      this.teamRoundwisePrizes[roundNumber].length > 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  onHomeClick() {
    this.router.navigate(['tabs/player-home']);
  }

  public getHandicapRange(category: string) {
    // console.log("getHandicapRange() ",category)
    let handicapRange: string = '';
    const _category = this.categories.find((c: any) => category === c.categoryName);
    if (!_category?.forGrouping) {
      handicapRange = '';
    } else {
      handicapRange = ' (' + _category.fromHandicap + ' - ' + _category.toHandicap + ')';
    }
    // this.categories.forEach((c: any) => {
    //   // CompetitionCategory
    //   // if (category === 'Seniors')
    //   //   console.log('getHandicapRange() ', category, c.categoryName, c.fromHandicap, c.toHandicap);
    //   if (category === c.categoryName) {
    //     // console.log("getHandicapRange() inside",category,c.categoryName,c.fromHandicap,c.toHandicap)
    //     if (!c?.forGrouping) {
    //       handicapRange = '';
    //     } else {
    //       handicapRange = ' (' + c.fromHandicap + ' - ' + c.toHandicap + ')';
    //     }
    //   }
    // });
    return handicapRange;
  }

  onBackpage() {
    this.location.back();
    // console.log('Boook');
    // this.router.navigate(['tabs/competition-details']);
  }
  goHome() {
    this.router.navigate(['tabs/player-home']);
  }

  async onDisplayPrizeDetails(prize: CompetitionPrizeInfo) {
    let _category = prize.categoryName ? prize.categoryName : '';
    let _title = `Prize for ${_category} - ${prize.title}`;
    if (prize.playerPos) {
      _title = `Prize for ${prize.playerPos}`;
    }
    let _message = {
      content: `${prize.prizeName}`,
    };

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        mode: 'infoDisplay',
        headerTitle: _title,
        message: _message,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {});
  }
  // filteredGameRoundPrizes() {
  //   let _filtered = [];
  //   if(this.searchQuery?.length > 0) {
  //     _filtered = this.gameRoundPrizes.filter((grp: GameroundPrize) => {
  //       // if(grp.)
  //     })
  //   } else _filtered = this.gameRoundPrizes;
  //   return _filtered;
  // }

  sortGameRoundPrizes() {
    this.gameRoundPrizes = this.gameRoundPrizes.sort((a, b) => {
      const isAOverall = a?.roundName === 'Overall';
      const isBOverall = b?.roundName === 'Overall';

      if (isAOverall && !isBOverall) {
        return -1;
      }
      if (!isAOverall && isBOverall) {
        return 1;
      }
      return a?.categoryName?.localeCompare(b?.roundName); // Alphabetical for others
    });
    // this.gameRoundPrizes.forEach(grp => {
    //   if (grp?.categoryPrizes) {
    //     grp.categoryPrizes = grp?.categoryPrizes.sort((a, b) => {
    //       // Prioritize "Overall", then sort others alphabetically
    //       const isAOverall = a?.categoryName === 'Overall';
    //       const isBOverall = b?.categoryName === 'Overall';
    //       if (isAOverall && !isBOverall) {
    //         return -1;
    //       }
    //       if (!isAOverall && isBOverall) {
    //         return 1;
    //       } else {
    //         if (a?.scoreType !== 'X') return -1;
    //         else if (a?.scoreType === 'X') return 1;
    //         else return a?.categoryName?.localeCompare(b?.categoryName); // Alphabetical for others
    //       }
    //     });
    //   }
    // });
  }
  onToggleViewMode(mode: string) {
    this.viewMode = mode;
  }


    async onZoomImage(prize: any, url: string) {
      const _description = `${prize?.title}<br>${prize?.prizeName}`;
      let _image = url;

      const modal: any = await this.modalCtl.create({
        component: ImageZoomPage,
        cssClass: 'self-adjustable-modal',
        componentProps: {
          image: _image,
          description: _description,
          descTopDown: 'bottom',
        },
      });
      await modal.present();
    }
}
